import React, { useState, useEffect } from "react";
// import { Grid, Paper } from "@material-ui/core";
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Checkbox,
  Button,
  Grid,
  CircularProgress,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import moment from "moment";
import TableSkeleton from "../../StyledComponents/TableSkeleton";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import "../Invoices/NewInvoice/Tables/style.css";
import EmptyData from "../../StyledComponents/Table/EmptyData";
// import { downloadInvoicesAttachmentMergedPDF } from "./actions";

import { downloadInvoicesAttachmentMergedPDF } from "../Home/actions";
const useStyles = makeStyles({
  iconButton: {
    visibility: "hidden",
    fontSize: "14px",
  },
  tableCell: {
    position: "relative",
    cursor: "pointer",
    "&:hover  $iconButton": {
      visibility: "visible",
    },
  },
  iconButtonActive: {
    position: "absolute",
    top: "50%",
    fontSize: "14px",
    transform: "translateY(-50%)",
    visibility: "visible",
    cursor: "pointer",
  },
  table: {
    // width: 0,
    minWidth: "100%",
    
  },
  inputStyle: {
    outline: "none",
    border: "none",
    background: "transparent",
  },
  inputHov: {
    cursor: "pointer",
    color: "blue",
    textDecoration: "underline",
  },
  tabCon: {
      width: "100%",
      textAlign: "center",
  },
  
});

const VendorIRTable = ({
  invoiceList,
  loading,
  invoiceAction,
  formState,
  setFormState,
//   visitedInvoices,
  setErrAlertMessage,
  setExcelInvoiceListData,
  setisOrderUpdated,
  setInvoicesList, 
  invoicesList ,
  
}) => {
  const list = Array.isArray(invoiceList) ? invoiceList : invoiceList ? [invoiceList] : [];
  const classes = useStyles();
  const [isSelectedAllInvoices, setIsSelectedAllInvoices] = useState(false);
  const [downloadAttachmentLoading, setDownloadAttachmentLoading] = useState(false);

  const addInvoiceInList = (id, vendorCode, email) => {
    console.log(id, vendorCode, email, "selected invoice");
     const ids = id.split(",").map((s) => s.trim());
    setInvoicesList((prev) => [...prev, id]);
    setExcelInvoiceListData((prev) => [...prev, id]);
    setFormState((prev) => ({
      ...prev,
      User: [...(prev.User || []), ...ids],
      vendorCode,
    }));
  };

  const removeInvoiceFromList = (id) => {
    setInvoicesList((prev) => prev.filter((i) => i !== id));
    setExcelInvoiceListData((prev) => prev.filter((i) => i !== id));
  };

  const removeAllInvoiceFromList = () => {
    setInvoicesList([]);
    setExcelInvoiceListData([]);
  };

  const addAllInvoiceInList = () => {
    const ids = [];
    list.forEach((item) => {
      if (!item?.users?.ids) return;
      ids.push(item.users.ids.trim());
    });
    setInvoicesList(ids);
    setExcelInvoiceListData(ids);
  };

  const downloadInvoicesAttachment = () => {
    downloadInvoicesAttachmentMergedPDF(
      invoicesList,
      setDownloadAttachmentLoading,
      setErrAlertMessage
    );
  };

  useEffect(() => {
    if (list.length > 0) {
      const totalUsers = list.reduce((acc, item) => acc + (item?.users?.ids ? 1 : 0), 0);
      setIsSelectedAllInvoices(invoicesList.length === totalUsers);
    }
  }, [invoicesList]);

  const Sorting = (value) => {
    setisOrderUpdated(false)
    setFormState((formState) => ({
      ...formState,
      OrderBy: value,
    }));
  };

  const isAscending = (value) => {
    setFormState((formState) => ({
      ...formState,
      isAsc: value,
    }));
  };
  return (
    <Grid container style={{ margin: "20px 0px", overflowY: "auto" }}>
      <Grid item xs={12}>
        {loading ? (
          <TableSkeleton
            style={{ width: "100%" }}
            noOfColumns={3}
            noOfLines={5}
            flag={true}
          />
        ) : (
          <TableContainer className={classes.tabCon}>
            <Table className={classes.table} size="small">
              <TableHead style={{ position: "sticky", top: -2, zIndex: "1" }}>
                <TableRow sx={{ backgroundColor: "#EFF2F4" }}>
                  <TableCell align="center" sx={{ fontWeight: "bold", color: "#031C30", width: "60px" }}>
                    <Checkbox
                      color="secondary"
                      checked={isSelectedAllInvoices}
                      onChange={(event) => {
                        setIsSelectedAllInvoices(event.target.checked);
                        event.target.checked
                          ? addAllInvoiceInList()
                          : removeAllInvoiceFromList();
                      }}
                    />
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{ fontWeight: "bold", color: "#031C30" }}
                    onClick={() => { isAscending(!formState?.isAsc); Sorting("vendorCode"); }}
                  >
                    <span className={classes.tableCell}>
                      {"Vendor Code "}
                      {formState.isAsc ? (
                        <ArrowUpwardIcon className={formState.OrderBy === "vendorCode" ? classes.iconButtonActive : classes.iconButton} />
                      ) : (
                        <ArrowDownwardIcon className={formState.OrderBy === "vendorCode" ? classes.iconButtonActive : classes.iconButton} />
                      )}
                    </span>
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{ fontWeight: "bold", color: "#031C30" }}
                    onClick={() => { isAscending(!formState?.isAsc); Sorting("iR_Users"); }}
                  >
                    <span className={classes.tableCell}>
                      {"IR User "}
                      {formState.isAsc ? (
                        <ArrowUpwardIcon className={formState.OrderBy === "iR_Users" ? classes.iconButtonActive : classes.iconButton} />
                      ) : (
                        <ArrowDownwardIcon className={formState.OrderBy === "iR_Users" ? classes.iconButtonActive : classes.iconButton} />
                      )}
                    </span>
                  </TableCell>
                </TableRow>
              </TableHead>
              {loading && (
                <TableSkeleton noOfColumns={3} noOfLines={5} flag={true} />
              )}
              <TableBody>
                {!loading && list.length === 0 && (
                  <TableRow>
                    <TableCell colSpan={3}>
                      <EmptyData />
                    </TableCell>
                  </TableRow>
                )}
                {list.map((item) => {
                  if (!item?.users?.ids) return null;
                  const rowId = item.users.ids.trim();
                  const rowEmails = item?.users?.iR_Users || "";
                  const isChecked = invoicesList.includes(rowId);

                  return (
                    <TableRow key={`${item.vendorCode}-${rowId}`}>
                      <TableCell align="center">
                        <Checkbox
                          color="secondary"
                          checked={isChecked}
                          onChange={(event) => {
                            event.target.checked
                              ? addInvoiceInList(rowId, item.vendorCode, rowEmails)
                              : removeInvoiceFromList(rowId);
                          }}
                        />
                      </TableCell>
                      <TableCell align="center">{item.vendorCode}</TableCell>
                      <TableCell align="center">{rowEmails}</TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Grid>
    </Grid>
  );
};

export default VendorIRTable;
